import React from "react";
import {
  List,
  ListItem,
  ListItemText,
  ListItemIcon,
  Collapse,
  Typography
} from "@material-ui/core";
import ExpandLess from "@material-ui/icons/ExpandLess";
import ExpandMore from "@material-ui/icons/ExpandMore";

import Delete from "@material-ui/icons/Delete";
import Done from "@material-ui/icons/Done";
import PropTypes from "prop-types";
import RegularErrors from "./RegularErrors";
import DatabaseErrors from "./DatabaseErrors";
import JoiErrors from "./JoiErrors";
import FileFlags from "./FileFlags";

import {
  getDatabaseErrors,
  getJoiErrors,
  getRegularErrors
} from "./UploadCommon";

const ValidateStep = props => (
  <div>
    {/* {props.isValidating && <div>Please wait while your files validate..</div>} */}
    <List>
      {props.files.map((file, fileIndex) => {
        const hasErrorsOrWarnings =
          file.errors.length || file.warnings.length || file.joiErrors.length;

        return [
          <ListItem
            button
            onClick={() => props.expand(file)}
            // eslint-disable-next-line
            key={`${file}_${fileIndex}`}
          >
            <ListItemIcon>
              {file.hasUploaded ? (
                <Done />
              ) : (
                <Delete
                  disabled
                  onClick={e => {
                    e.stopPropagation();
                    if (!props.someFilesAreUploading)
                      props.removeFile(fileIndex);
                  }}
                />
              )}
            </ListItemIcon>
            <ListItemText>
              <span>{file.name}</span>
            </ListItemText>
            <ListItemIcon>
              <FileFlags file={file} />
            </ListItemIcon>
            <ListItemIcon>
              {props.isExpanded(file) ? <ExpandLess /> : <ExpandMore />}
            </ListItemIcon>
          </ListItem>,
          <Collapse
            in={props.isExpanded(file)}
            // eslint-disable-next-line
            key={`${file}_expand_${fileIndex}`}
          >
            <List>
              <ListItem>
                <ListItemText>
                  {hasErrorsOrWarnings
                    ? [
                        <RegularErrors
                          key={`regular_${file}`}
                          {...props}
                          rows={file.warnings.filter(row => !row.report)}
                          level="warn"
                        />,
                        <DatabaseErrors
                          key={`db_warn_${file}`}
                          {...props}
                          style={{ border: "5px solid blue" }}
                          rows={getDatabaseErrors(file)}
                          level="warning"
                        />,
                        <DatabaseErrors
                          key={`db_err_${file}`}
                          {...props}
                          style={{ border: "5px solid blue" }}
                          rows={getDatabaseErrors(file)}
                          level="error"
                        />,
                        <RegularErrors
                          key={`reg_err_${file}`}
                          rows={getRegularErrors(file)}
                          level="error"
                        />,
                        <JoiErrors {...props} rows={getJoiErrors(file)} />
                      ]
                    : []}
                </ListItemText>
              </ListItem>
            </List>
          </Collapse>
        ];
      })}
    </List>
    {!props.files.length ? (
      <Typography>
        <b>
          You have no files. Please click <i>Back</i> and add some.
        </b>
      </Typography>
    ) : null}
    {!props.noFilesHaveValidationErrors ? (
      <Typography>
        <b>
          Please remove the file with errors in it before continuing. You will
          need to remove the file and re-add it after correcting.
        </b>
      </Typography>
    ) : null}
  </div>
);
ValidateStep.propTypes = {
  expand: PropTypes.func.isRequired,
  isExpanded: PropTypes.func.isRequired,
  removeFile: PropTypes.func.isRequired,
  someFilesAreUploading: PropTypes.bool.isRequired,
  noFilesHaveValidationErrors: PropTypes.bool.isRequired,
  files: PropTypes.arrayOf(PropTypes.object).isRequired
};
export default ValidateStep;
